export const loaderStyle = {
	wrapper: {
		display: 'flex',
	},
};
